<template>
    
</template>

<script>
    export default {
        name: "loading",
        data(){
          return{

          }
        },
        created(){
          //返回重定向
          // if(this.$store.state.isLogin == 1 && this.$route.params.openid){
          //   this.$router.replace("/");
          // }
          //是否需要授权登录
          if(this.$route.params.openid){
            this.$api.get("",{
              api:'/wechat/server/get_user_info',
              openid: this.$route.params.openid
            },res=>{
              if(res.status == 1){
                this.$store.commit("setLogin");
                // this.$store.commit("setfirstlink");
                this.$router.replace("/");
                // window.location.href = '/mooc-wx';
              }else{
                console.log('shibai');
              }
            })
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue